import { SupportTicketForm } from "./SupportTicketForm";
import { Proposal } from "../../types/Proposal";
import { ModalWindow } from "../modal/ModalWindow";
import {useMemo, useState} from "react";
import { Typography } from "@mui/material";


interface SupportDialogProps {
    proposal: Proposal
    onClose: () => void
}

export function SupportDialog({onClose, proposal}:SupportDialogProps) {
    const [loading, setLoading] = useState(false);
    let title = useMemo(() => {
        const title = "proposal " + proposal.id.substring(0, 6);
        const params:string[] = [];
        if(proposal.address) {
            params.push(proposal.address);
        }

        if(proposal.area && proposal.price) {
            params.push(` ${Math.round(proposal.area / 100)}m² / ${Math.round(proposal.price / 100)}$`);
        } else if(proposal.area) {
            params.push(` ${Math.round(proposal.area / 100)}}m²`);
        } else if(proposal.price) {
            params.push(` ${Math.round(proposal.price / 100)}$`);
        }
        return title + (params.length > 0 ? ` (${params.join(", ")})` : "");
    }, [proposal])

    return <ModalWindow title={"Support Ticket"} loading={loading} onClose={onClose}>
        <Typography className={"mb mb-15"}>
            If you have any questions
            about&nbsp;<Typography component={"span"} color={"primary"} variant={"body2"}>{title}</Typography>&nbsp;,
            please feel free to ask, and our support team will respond as soon as possible.
        </Typography>
        <SupportTicketForm
            setLoading={setLoading}
            defaultTitle={title}
            margin={"0 auto 0"}
            entityId={proposal.id}
            onSubmit={() => onClose()} />
    </ModalWindow>
}